import { ExclamationTriangleIcon, XMarkIcon } from '@heroicons/react/24/outline';
import React from 'react';

type PenalModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

function PenalModal({ isOpen, onClose }: PenalModalProps) {
  if (!isOpen) {
    return null;
  }

  return (
    <div
      className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/50"
      onClick={(e) => { if (e.target === e.currentTarget) { onClose(); } }}
      style={{ backdropFilter: 'blur(4px)' }}
    >
      <div className="relative max-h-[80vh] w-[90%] max-w-2xl overflow-y-auto rounded-xl bg-white p-8 shadow-2xl">
        <button
          type="button"
          onClick={onClose}
          className="absolute top-3.5 right-4 text-gray-400 transition-colors hover:text-gray-600"
        >
          <XMarkIcon className="h-5 w-5" />
        </button>

        <div className="mb-5 flex items-center gap-2.5">
          <ExclamationTriangleIcon className="h-6 w-6 text-red-600" />
          <h2 className="text-base font-extrabold text-red-600">
            5 ans de prison et 300 000 € d&apos;amende
          </h2>
        </div>

        {/* Article 226-21 */}
        <div className="mb-5 rounded-lg border border-red-200 bg-red-50 p-4">
          <div className="mb-2 text-xs font-bold tracking-wider text-red-600 uppercase">
            Article 226-21
          </div>
          <p className="text-[13px] leading-relaxed text-gray-900">
            Le fait de détourner des données à caractère personnel de leur finalité est puni de{' '}
            <strong>cinq ans d&apos;emprisonnement et de 300 000 euros d&apos;amende</strong>.
          </p>
          <a
            href="https://www.legifrance.gouv.fr/codes/article_lc/LEGIARTI000006417981"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-2.5 inline-block text-[11px] font-semibold text-rgpd-blue hover:underline"
          >
            &rarr; Voir sur Légifrance
          </a>
        </div>

        {/* CNIL section */}
        <div className="rounded-lg border border-gray-200 bg-gray-50 p-4">
          <div className="mb-2.5 text-xs font-bold tracking-wider text-rgpd-blue-dark uppercase">
            La prospection commerciale par le syndic
          </div>
          <p className="mb-2.5 text-[13px] leading-relaxed text-gray-900">
            La prospection commerciale effectuée par le syndic nécessite le recueil du consentement
            des copropriétaires, car l&apos;objectif de la prospection n&apos;est pas compatible avec
            l&apos;objectif initial de la collecte des données.
          </p>
          <a
            href="https://www.cnil.fr/fr/la-gestion-des-donnees-personnelles-au-sein-dune-copropriete"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block text-[11px] font-semibold text-rgpd-blue hover:underline"
          >
            &rarr; Source CNIL
          </a>
        </div>
      </div>
    </div>
  );
}

export default PenalModal;
